import { allRoutes } from "context/SiteSettingsContext/routes";

export const getPath = (routes: ReturnType<typeof allRoutes>, path: string) => {
  try {
    const stringUrl = routes.uiComPage({ path });

    const url = new URL(stringUrl);

    return url.pathname;
  } catch (e) {
    console.log(e);
  }

  // Fallback to the path
  return path;
};
